$(document).ready(function() {
  const heroModule = $('.animateHeroModule');
  const firstTitle = $('.animateHeroModule__titleFirst');
  const secondTitleWords = $('.animateHeroModule__titleSecond p');
  const videoSection = $('.animateVideoModule');
  const video = $('.animateVideoModule__video').get(0);
  const content = $('.animateHeroModule__content');
  const videoContent = $('.animateVideoModule__content');
  let  frameNumber = 0;

  video.addEventListener('loadeddata', function() {
    this.currentTime = 0;

    videoSection.css({
      'height': `${(Math.floor(video.duration)) * 300}px`,
    });
  });

  if(window.innerWidth > 960) {
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    video.removeAttribute('playsinline');
  }

  $.jScrollability([
    {
      'selector': heroModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        firstTitle.css({
          'transform': `translateX(-${pcnt * 160}px)`,
          'opacity': `${1 - (pcnt * 2)}`,
        });

        if (pcnt >= 0.5) {
          heroModule.addClass('animateHeroModule--activeTitle');
        } else {
          heroModule.removeClass('animateHeroModule--activeTitle');
        }

        secondTitleWords.each(function(i) {
          let index = i + 1;
          let opacityValue = 0.4 + (index / 10);
          let extraOpacity = ((pcnt - opacityValue) * 4) + (index / 10);

          $(this).css({
            'opacity': `${extraOpacity}`,
          });
        });

        if ($el.height() - window.pageYOffset * 1.2 <= window.innerHeight) {
          videoSection.addClass('animateVideoModule--active');
          content.css({'opacity': `${(1 - pcnt) * 6.25}`});
          videoSection.css({
            'opacity': `${Math.abs(((1 - pcnt) * 6.25) - 1)}`,
          });
        } else {
          videoSection.removeClass('animateVideoModule--active');
          content.css({'opacity': '1'});
          videoSection.css({
            'opacity': '1',
          });
        }

        if(window.innerWidth > 960) {
          if (videoSection[0].getBoundingClientRect().top + window.innerHeight  <= 0) {
            frameNumber = Math.abs(videoSection[0].getBoundingClientRect().top + window.innerHeight) / 100;
            video.currentTime  = frameNumber;
          } else {
            video.currentTime  = 0;
          }
        }
      }
    }
  ]);
}());
